module.exports = __webpack_public_path__ + "img/instagram.731db202.svg";